import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SubFooterWrapper from "./subFooter.style";
import propTypes from "prop-types";
import btnNext from "../../assets/images/icons/icon_btn-next-icon.svg";
import pencil from "../../assets/images/icons/icon_pencil.svg";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "../../helpers/utils";

const SubFooter = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { isWorldcup, businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  const onClick = (itemIndex) => {
    let _activeIndex = activeIndex ? [...activeIndex] : [];

    if (_activeIndex.length === 0) {
      _activeIndex.push(itemIndex);
    } else {
      const index = _activeIndex.indexOf(itemIndex);
      if (index === -1) {
        _activeIndex.push(itemIndex);
      } else {
        _activeIndex.splice(index, 1);
      }
    }

    setActiveIndex(_activeIndex);
  };
  return (
    <SubFooterWrapper>
      <div
        className={
          "next-wrapper " +
          (props.i18n.language === "ar" ? "ar" : "") +
          (isWorldcup ? " worldcup_payment_bg_img_footer" : "")
        }
      >
        <div className="container">
          <div className="row pb-5">
            <div className="col-12 price-button-wrapper">
              {!props.hidePriceSection && (
                <div className="total-price">
                  <div className="img-wrapper">
                    <img src={props.icon} alt="" color={businessColor} />
                  </div>
                  <div className="des">
                    <p
                      className={
                        businessLine
                          ? `des_vat_color-${businessLine}`
                          : "des_vat_color"
                      }
                    >
                      {" "}
                      {props.i18n.t("TOTAL_PRICE")}{" "}
                    </p>
                    <p
                      className={
                        businessLine
                          ? `des_vat des_vat_color-${businessLine}`
                          : " des_vat des_vat_color"
                      }
                    >
                      {props.i18n.t("including_vat")}
                    </p>
                    {!props.hideSummary && (
                      <Button
                        className="p-button-link p-0 "
                        onClick={() => onClick(0)}
                      >
                        {props.i18n.t("VIEW_SUMMARY")}
                      </Button>
                    )}
                  </div>
                  <div className="price" style={{ color: businessColor }}>
                    <span className="d-inline-block">
                      {" "}
                      {props.i18n.t("SAR")}{" "}
                    </span>
                    <b className="lato d-inline-block mx-2"> {props.total} </b>
                    {+props.total !== +props.beforeTotal && <span><sup><s>{props.beforeTotal}</s></sup></span>}
                  </div>
                </div>
              )}
              <div className="btn-wrapper">
                {props.showMakeChangeBtn && (
                  <React.Fragment>
                    <Button
                      onClick={props.makeChangeHandler}
                      className={
                        businessLine
                          ? `btn secondary_outline next text-uppercase px-3 secondary_outline-${businessLine}`
                          : "btn secondary_outline next text-uppercase px-3"
                      }
                      style={{
                        color: businessColor,
                        borderColor: businessColor,
                      }}
                    >
                      {props.i18n.t("MAKE_CHANGES")}
                      <img src={pencil} alt="" />
                    </Button>
                    {/* <Button
                        to={nextPayment ? nextPayment : "/"}
                        className="btn primary next text-uppercase px-3"
                      >
                        {props.i18n.t("PAYMENT")}
                        <img src={btnNext} alt="" />
                      </Button> */}
                  </React.Fragment>
                )}

                {!props.hideNextBtn && (
                  <Button
                    type="Button"
                    loading={props.nextBtnLoading}
                    disabled={props.nextBtnDisabled}
                    onClick={props.nextBtnHandler}
                    className="btn primary next text-uppercase px-3"
                    style={{ background: businessColor }}
                  >
                    {props.nextBtnLabel}
                    <img src={btnNext} alt="" />
                  </Button>
                )}
              </div>
            </div>
            {!props.hidePriceSection && (
              <div className="col-12">
                <Accordion
                  multiple
                  activeIndex={activeIndex}
                  onTabChange={(e) => setActiveIndex(e.index)}
                >
                  <AccordionTab>
                    <div className="price_description">
                      {props?.summary?.map((ele, i) =>
                        +ele.price > 0 ? (
                          <div key={"summ_" + i} className="cell">
                            <div className="detail">
                              {props.i18n.t(ele.code)}
                            </div>
                            <div className="cost lato">{ele.price}</div>
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
            )}
          </div>
        </div>
      </div>
    </SubFooterWrapper>
  );
};

SubFooter.propTypes = {
  nextBtnLabel: propTypes.string,
  nextBtnHandler: propTypes.func,
  nextBtnLoading: propTypes.bool,
  icon: propTypes.any,
  hideNextBtn: propTypes.bool,
  nextBtnDisabled: propTypes.bool,
  loading: propTypes.bool,
  hidePriceSection: propTypes.bool,
  showMakeChangeBtn: propTypes.bool,
  makeChangeLabel: propTypes.string,
  makeChangeHandler: propTypes.func,
  summary: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string,
      price: propTypes.string,
      code: propTypes.string,
    })
  ),
  hideSummary: propTypes.bool,
  total: propTypes.string,
  beforeTotal:propTypes.any
};

export default withTranslation()(SubFooter);
